import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { compose, withPropsOnChange } from 'recompose';
import { fetchAllCampaigns } from 'dash-front/admin/actions/campaigns';
import { getEntities } from 'dash-front/selectors';
import { SelectField, MenuItem } from 'material-ui';
import { responseStatusIsOk, toIdArray, addToQuery, safeParse } from 'dash-front/helpers';
import { fetchUsers } from 'dash-front/admin/actions/accounts';

const withAdmin = withPropsOnChange('user', ({ user }) => ({
    isAdmin: user && Array.isArray(user.roles) && user.roles.indexOf('admin') > -1
}));

const getSelectedValues = qsVal => {
    const parsed = safeParse(qsVal);
    return Array.isArray(parsed) ? parsed : [];
};

const CampaignsSelect = compose(
    connect(state => ({
        users: getEntities(state).users,
        user: state.user,
        campaigns: getEntities(state).campaignsList,
        selected: _.get(state.routing, ['location', 'query', 'campaigns'])
    })),
    withAdmin
)(
    class _CampaignsSelect extends React.PureComponent {
        state = { ids: null };

        componentDidMount() {
            const { isAdmin, dispatch } = this.props;
            dispatch(fetchAllCampaigns()).then(res => {
                if (responseStatusIsOk(res.status)) {
                    const ids = toIdArray(res.body);
                    this.setState({ ids }, () => {
                        if (!getSelectedValues(this.props.selected).length) {
                            this.onChange(null, null, ids);
                        }
                    });
                }
            });
            if (isAdmin) {
                dispatch(fetchUsers());
            }
        }

        onChange = (e, i, values) => {
            addToQuery('campaigns', JSON.stringify(values));
        };

        render() {
            const { campaigns, isAdmin, users, selected: dirtyValues } = this.props;
            const { ids } = this.state;
            const selected = getSelectedValues(dirtyValues);
            return (
                <div>
                    <SelectField
                        value={selected}
                        multiple
                        onChange={this.onChange}
                        floatingLabelText={'Select campaigns'}
                    >
                        {Array.isArray(ids)
                            ? Object.keys(campaigns).map(id => {
                                  const campaign = campaigns[id];
                                  const label =
                                      (isAdmin && users
                                          ? _.get(users, [campaign.userId, 'username'], '') + ' | '
                                          : '') + campaign.title;
                                  return (
                                      <MenuItem
                                          key={id}
                                          value={id}
                                          checked={selected && selected.indexOf(id) > -1}
                                          primaryText={label}
                                          insetChildren
                                      />
                                  );
                              })
                            : null}
                    </SelectField>
                </div>
            );
        }
    }
);

export default CampaignsSelect;



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Hub/CampaignsSelect.js
 **/